import { render, staticRenderFns } from "./UnverifiedProfile.vue?vue&type=template&id=38ce0c62&scoped=true&"
import script from "./UnverifiedProfile.vue?vue&type=script&lang=js&"
export * from "./UnverifiedProfile.vue?vue&type=script&lang=js&"
import style0 from "./UnverifiedProfile.vue?vue&type=style&index=0&id=38ce0c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce0c62",
  null
  
)

export default component.exports